import { Menu, MenuItem } from "@mui/material";
import SwapVertOutlinedIcon from "@mui/icons-material/SwapVertOutlined";
import { Dispatch, SetStateAction, useState } from "react";
import { FONT_FAMILY } from "../../theme";
import { FilterAndSortButton } from "../TracksPageComponents/styles";
import { sortMenuStyles } from "../TracksPageComponents/styles";

export interface ProjectFilesSortMenuProps {
  filesSortBy: number;
  setFilesSortBy: Dispatch<SetStateAction<0 | 1 | 2>>;
}

export const ProjectFilesSortMenu: React.FC<ProjectFilesSortMenuProps> = ({
  setFilesSortBy,
}) => {
  const [sortAnchorEl, setSortAnchorEl] = useState<null | HTMLElement>(null);
  const openSortMenu = Boolean(sortAnchorEl);

  const handleOpenSortDropdown = (event: React.MouseEvent<HTMLButtonElement>) =>
    setSortAnchorEl(event.currentTarget);

  const handleSortDropdownClose = () => setSortAnchorEl(null);

  const handleSortSelection = (sortValue: 0 | 1 | 2) => {
    setFilesSortBy(sortValue);
    handleSortDropdownClose();
  };

  return (
    <>
      <FilterAndSortButton
        aria-controls={openSortMenu ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={openSortMenu ? "true" : undefined}
        onClick={handleOpenSortDropdown}
        sx={{ ...sortMenuStyles.button, marginLeft: "10px" }}
      >
        <SwapVertOutlinedIcon sx={{ margin: "5px" }} />
        Sort
      </FilterAndSortButton>
      <Menu
        id="basic-menu"
        anchorEl={sortAnchorEl}
        open={openSortMenu}
        onClose={handleSortDropdownClose}
        PaperProps={{ style: sortMenuStyles.paperProps }}
        sx={sortMenuStyles.menu}
      >
        {["Title", "Last Modified", "Size"].map((label, index) => (
          <MenuItem
            key={label}
            onClick={() => handleSortSelection(index as 0 | 1 | 2)}
            sx={{ fontFamily: FONT_FAMILY }}
          >
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
